import "./FuelLoading.scss";

export default function FuelLoading({ text = "Preparing Checkout..." }) {
  return (
    <div className="fuel-loading-container">
      <div className="fuel-road-scene">
        <div className="fuel-car-wrapper">🚗</div>
        <div className="fuel-road-line"></div>
      </div>
      <p className="fuel-loading-text">{text}</p>
    </div>
  );
}
